// Marca do item com o preço especial do order bump (2026-10-26). O desconto
// vale para uma unidade e já está no total da linha.
export function OrderBumpTag({ discount, className = "" }: { discount?: number; className?: string }) {
  if (!discount || discount <= 0) return null;
  const value = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(discount);
  return (
    <p className={`inline-flex rounded-md bg-emerald-50 px-1.5 py-0.5 text-[11px] font-semibold text-emerald-700 ${className}`}>
      Oferta especial: −{value} (1 un.)
    </p>
  );
}
